export default __webpack_public_path__ + "static/media/2.173e4bc7.jpeg";